import React from 'react';
import { Badge, Button } from 'components/ui';
import {
  ORIENTATION_DATE,
  PRIORITY_DEADLINE,
  PROGRAM_DATES,
  REGULAR_DEADLINE,
} from 'constants/dates.constants';
import type { SclaApplicationYear } from '../../api/getSclaApplicationYears';
import {
  SCLA_ELIGIBILITY,
  SCLA_TIME_NOTE,
  SCLA_WHAT_YOU_NEED,
} from '../../copy/sclaProgramCopy';
import formatSclaDate from './formatSclaDate';
import SclaProgramIntro from './SclaProgramIntro';
import shortSclaScheduleDate from './shortSclaScheduleDate';
import styles from './SclaHome.module.scss';


interface ISclaNewStudentHomeProps {
  year: SclaApplicationYear;
  isStarting: boolean;
  onStart: () => void;
}

export default function SclaNewStudentHome({
  year,
  isStarting,
  onStart,
}: ISclaNewStudentHomeProps) {
  const openingDate = formatSclaDate(year.opensAt, true);

  return (
    <>
      <div className={styles.titleRow}>
        <h1 className={`${styles.pageTitle} txt-title`}>SCLA Application</h1>
      </div>
      <p className={styles.subtitle}>
        Summer Coding Leadership Academy {year.cohortYear}
      </p>

      <SclaProgramIntro />

      <section className={`${styles.card} ${styles.hero}`}>
        {year.status === 'open' ? (
          <Badge tone="success">{year.cohortYear} · Accepting applications</Badge>
        ) : null}
        {year.status === 'upcoming' ? (
          <Badge tone="neutral">
            {year.cohortYear} · Opens {openingDate}
          </Badge>
        ) : null}
        {year.status === 'closed' ? (
          <Badge tone="neutral">Applications closed</Badge>
        ) : null}
        <h2 className={`${styles.heroTitle} txt-heading`}>Summer Coding Leadership Academy</h2>
        <div className={styles.heroActions}>
          {year.status === 'open' ? (
            <Button
              className={styles.heroButton}
              loading={isStarting}
              onClick={onStart}
            >
              Start {year.cohortYear} application
            </Button>
          ) : null}
          {year.status === 'upcoming' ? (
            <Button disabled>Not open yet</Button>
          ) : null}
          {year.status === 'open' ? (
            <span className={styles.heroNote}>{SCLA_TIME_NOTE}</span>
          ) : null}
        </div>
      </section>


      <div className={styles.facts}>
        <section className={`${styles.card} ${styles.fact}`}>
          <h3 className={styles.factLabel}>Who can apply</h3>
          <p className={styles.muted}>{SCLA_ELIGIBILITY}</p>
        </section>
        <section className={`${styles.card} ${styles.fact}`}>
          <h3 className={styles.factLabel}>Deadlines</h3>
          <p className={styles.muted}>Priority: {shortSclaScheduleDate(PRIORITY_DEADLINE)}</p>
          <p className={styles.muted}>Final: {shortSclaScheduleDate(REGULAR_DEADLINE)}</p>
        </section>
        <section className={`${styles.card} ${styles.fact}`}>
          <h3 className={styles.factLabel}>Program</h3>
          <p className={styles.muted}>Orientation: {shortSclaScheduleDate(ORIENTATION_DATE)}</p>
          <p className={styles.muted}>Program dates: {shortSclaScheduleDate(PROGRAM_DATES)}</p>
        </section>
        <section className={`${styles.card} ${styles.fact}`}>
          <h3 className={styles.factLabel}>What you&apos;ll need</h3>
          <p className={styles.muted}>{SCLA_WHAT_YOU_NEED}</p>
        </section>
      </div>

    </>
  );
}
